<template>
  <a-card title="Tạo mới công việc" class="root-card">
    <a-form-model layout="vertical">
      <a-form-model-item label="Tiêu đề">
        <a-input placeholder="Tiêu đề" v-model="formData.title" />
      </a-form-model-item>
      <a-form-model-item label="Mô tả">
        <a-textarea placeholder="Mô tả" v-model="formData.description" :auto-size="{ minRows: 4, maxRows: 8 }"></a-textarea>
      </a-form-model-item>
      <a-form-model-item label="Kịch bản">
        <a-card hoverable>
          <template slot="actions">
            <a-icon key="setting" @click="() => {this.visible.chooseScenarioModal = true}" type="setting" />
          </template>
          <a-card-meta v-if="!!choosedScenario" :title="choosedScenario?.title" :description="choosedScenario?.description">
          </a-card-meta>
        </a-card>
      </a-form-model-item>
      <a-form-model-item v-if="!!choosedScenario">
        <a-form-model-item v-for="param in choosedScenario.params" :key="param.key" :label="`${param.title}`">
          <template v-if="param.tag_index">
            <a-select v-model="scenarioParams[param.key]" :placeholder="param.description || param.title" allowClear>
              <a-select-option v-for="tag in tagsByIndex(param.tag_index)" :key="String(tag.id)" :value="String(tag.id)">
                <a-tag>{{ tag.title }}</a-tag>
              </a-select-option>
            </a-select>
          </template>
          <template v-else-if="param.options">
            <a-select v-model="scenarioParams[param.key]" :placeholder="param.description || param.title" allowClear>
              <a-select-option v-for="option in param.options" :key="String(option.value)" :value="String(option.value)">
                {{ option.title }}
              </a-select-option>
            </a-select>
          </template>
          <template v-else-if="param.type === 'string'">
            <a-input v-model="scenarioParams[param.key]" :placeholder="param.description || param.title" />
          </template>
          <template v-else-if="param.type === 'number'">
            <a-input-number v-model="scenarioParams[param.key]" :placeholder="param.description || param.title" style="width: 100%" />
          </template>
          <template v-else-if="param.type === 'boolean'">
            <a-select v-model="scenarioParams[param.key]" :placeholder="param.description || param.title">
              <a-select-option value="true">True</a-select-option>
              <a-select-option value="false">False</a-select-option>
            </a-select>
          </template>
        </a-form-model-item>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" :loading="loading.createJob" @click="handleCreateJob"><a-icon type="save" /> Tạo mới</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-modal id="scenarios-modal" width="1000px" v-model="visible.chooseScenarioModal" title="Danh sách kịch bản" @ok="() => visible.chooseScenarioModal = false">
      <div v-if="!scenarios || scenarios?.length == 0">Không có kịch bản nào!</div>
      <a-list :grid="{ gutter: 16, column: 3 }" :data-source="scenarios">
        <a-list-item slot="renderItem" slot-scope="scenario">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="add" type="check" @click="chooseScenario(scenario.id)"/>
            </template>
            <a-card-meta style="height: 115px; white-space: pre-wrap;text-overflow: ellipsis;overflow: hidden;" :title="scenario.title" :description="scenario.description">
            </a-card-meta>
          </a-card>
        </a-list-item>
      </a-list>
    </a-modal>
  </a-card>
</template>
<style scoped>
#scenarios-modal .card-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
}

#scenarios-modal .card {
  margin-bottom: 16px;
}

.ant-form-item {
  margin-bottom: 10px !important;
}
</style>
<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  data() {
    return {
      loading: {
        createJob: false
      },
      visible: {
        chooseScenarioModal: false,
        createJob: false
      },
      choosedScenarioId: undefined,
      formData: {},
      scenarioParams: {}
    }
  },
  mounted() {
    this.fetchScenarios();
    this.fetchTags({
      index: 'x-account'
    });
  },
  computed: {
    ...mapGetters('scenario', {
      scenarios: "listScenarios"
    }),

    ...mapGetters('tag', {
      tags: 'getTags'
    }),

    choosedScenario() {
      return this.choosedScenarioId && this.scenarios && this.scenarios.length > 0 ? this.scenarios.find(scenario => scenario.id == this.choosedScenarioId) : undefined;
    }
  },
  methods: {
    ...mapActions('scenario', {
      fetchScenarios: "fetchScenarios",
      getScenarioConfig: "getScenarioConfig",
      setScenarioConfig: "setScenarioConfig",
    }),

    ...mapActions('job', {
      createJob: "createJob"
    }),

    ...mapActions("tag", {
      fetchTags: "fetchTags"
    }),

    async chooseScenario(scenarioId) {
      this.choosedScenarioId = scenarioId;
      this.visible.chooseScenarioModal = false;
      await this.restoreScenarioParams();
    },

    async saveScenarioParams() {
      if (this.choosedScenarioId) {
        const savedParams = {
          scenario_id: this.choosedScenarioId,
          raw_metadata: JSON.stringify(this.scenarioParams)
        }
        await this.setScenarioConfig(savedParams);
      }
    },

    tagsByIndex(index) {
      return this.tags.filter(t => t.index == index);
    },

    async restoreScenarioParams() {
      if (!this.choosedScenarioId || !this.choosedScenario) return;

      const rawMetadata = await this.getScenarioConfig(this.choosedScenarioId);
      const savedParams = rawMetadata ? JSON.parse(rawMetadata) : undefined;

      this.scenarioParams = this.choosedScenario.params.reduce((acc, param) => {
        acc[param.key] = savedParams && savedParams[param.key] !== undefined ? savedParams[param.key] : (param.default != undefined ? String(param.default) : undefined);
        return acc;
      }, {});
    },

    async handleCreateJob() {
      await this.saveScenarioParams();
      this.loading.createJob = true;

      try {
        const {message} = await this.createJob({...this.formData, ...{
          params: this.scenarioParams,
          scenario_id: this.choosedScenarioId
        }});
        
        this.$message.success(message);
        this.$router.push({name: 'ListJob'});
      }
      catch(error) {
        this.$message.error(error?.response?.data?.error?.message || error?.response?.data || error?.message);
      }

      this.loading.createJob = false;
    }
  }
};
</script>
